<template>
  <commonSelect
    :value="value"
    @input="v=>$emit('input',v)"
    :placeholder="placeholder"
    :clearable="clearable"
    idKey="ChannelId"
    labelKey="ChannelName"
    :get-data-func="getDataFunc"
  />
</template>
<script>
import commonSelect from "@/components/common/select";
export default {
  props: {
    value: {},
    clearable: {
      type: Boolean,
      default: true,
    },
    placeholder: {
      type: String,
      default: "请选择渠道",
    },
  },
  components: { commonSelect },
  data() {
    return {
      api: require("@/api/ba/channel").default,
    };
  },
  methods: {
    getDataFunc(params) {
      return new Promise((resolve, reject) => {
        this.api.list({ Status: 1 }).then((res) => {
          resolve(res);
        });
      });
    },
  },
};
</script>

